import script from './component-lib.esm4.js';
import normalizeComponent from '../../external/vue-runtime-helpers/dist/component-lib.esm.js';
import createInjector from '../../external/vue-runtime-helpers/dist/inject-style/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('details', {
    ref: "root",
    staticClass: "v-accordion-item",
    class: _vm.classes,
    style: _vm.styles,
    attrs: {
      "open": _vm.isOpen
    }
  }, [_c('summary', {
    ref: "summary",
    staticClass: "v-accordion-item__header",
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.handleClick.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "v-accordion-item__header__inner"
  }, [_c('div', {
    staticClass: "v-accordion-item__header__opener"
  }, [_vm.$slots.icon ? _c('div', {
    staticClass: "v-accordion-item__header__icon"
  }, [_c('span', {
    staticClass: "v-accordion-item__header__circle"
  }, [_vm.variant === 'success' ? _c('CheckIcon') : _vm.variant === 'error' ? _c('ErrorIcon') : _vm._t("icon")], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "v-accordion-item__header__title"
  }, [_vm._t("title", function () {
    return [_vm._v("\n            " + _vm._s(_vm.title) + "\n          ")];
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "v-accordion-item__header__actions"
  }, [_vm._t("actions", function () {
    return [_c('ChevronIcon', {
      staticClass: "v-accordion-item__header__actions__icon",
      attrs: {
        "direction": "right",
        "color": "gray600"
      }
    })];
  })], 2)])]), _vm._v(" "), _c('div', {
    ref: "content",
    staticClass: "v-accordion-item__content"
  }, [_vm._t("default")], 2)]);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-d0ab29da_0", {
    source: ".v-accordion-item[data-v-d0ab29da]{background:#fff;border:1px solid transparent;border-radius:var(--g-border-radius-standard);border-radius:min(var(--g-border-radius-standard),var(--g-border-radius-min));display:flex;font-family:var(--g-font-body-family);flex:1 1 100%;margin-bottom:.5rem;overflow:hidden;text-align:left;transition:border-color var(--g-transition-speed)}.v-accordion-item[data-v-d0ab29da]:last-child{margin-bottom:0}.v-accordion-item[data-v-d0ab29da]:focus,.v-accordion-item[data-v-d0ab29da]:hover{border-color:var(--g-color-primary)}.v-accordion-item[data-v-d0ab29da]:focus-within{border-color:var(--g-color-primary)}.v-accordion-item--error .v-accordion-item__header__circle[data-v-d0ab29da],.v-accordion-item--success .v-accordion-item__header__circle[data-v-d0ab29da]{font-size:1.25rem}.v-accordion-item--success:focus .v-accordion-item__header__opener[data-v-d0ab29da],.v-accordion-item--success:hover .v-accordion-item__header__opener[data-v-d0ab29da],.v-accordion-item--success[open] .v-accordion-item__header__opener[data-v-d0ab29da]{opacity:1}.v-accordion-item--success .v-accordion-item__header__opener[data-v-d0ab29da]{opacity:.75}.v-accordion-item--success .v-accordion-item__header__circle[data-v-d0ab29da]{background:var(--g-color-success);border-color:var(--g-color-success);color:#fff}.v-accordion-item--error .v-accordion-item__header__circle[data-v-d0ab29da]{background:var(--g-color-error);border-color:var(--g-color-error);color:#fff}.v-accordion-item--disabled[data-v-d0ab29da]:focus,.v-accordion-item--disabled[data-v-d0ab29da]:hover{border-color:transparent}.v-accordion-item--disabled[data-v-d0ab29da]:focus-within{border-color:transparent}.v-accordion-item--disabled .v-accordion-item__header[data-v-d0ab29da]{cursor:default;opacity:.75;pointer-events:none}.v-accordion-item[open][data-v-d0ab29da]{border-color:var(--g-color-primary)}.v-accordion-item[open] .v-accordion-item__header__actions__icon[data-v-d0ab29da]{transform:rotate(0)}.v-accordion-item__header[data-v-d0ab29da]{cursor:pointer;list-style:none;transition:background-color var(--g-transition-speed)}.v-accordion-item__header[data-v-d0ab29da]:focus,.v-accordion-item__header[data-v-d0ab29da]:hover{background:var(--c-header-active-color)}.v-accordion-item__header[data-v-d0ab29da]::-webkit-details-marker{display:none}.v-accordion-item__header__inner[data-v-d0ab29da]{display:flex}.v-accordion-item__header__opener[data-v-d0ab29da]{align-items:center;display:flex;padding:.5rem .75rem;flex:1 1 auto}.v-accordion-item__header__icon[data-v-d0ab29da]{margin-right:1rem;position:relative}@media (min-width:544px){.v-accordion-item__header__icon[data-v-d0ab29da]{margin-right:1.25rem}}.v-accordion-item__header__circle[data-v-d0ab29da]{align-items:center;background:0 0;border:1px solid var(--g-color-primary);border-radius:50%;color:var(--g-color-primary);font-size:1rem;display:inline-flex;height:1.75rem;justify-content:center;width:1.75rem}.v-accordion-item__header__title[data-v-d0ab29da]{font-size:1rem;font-weight:600;line-height:1.3}.v-accordion-item__header__actions[data-v-d0ab29da]{display:flex;align-items:center;padding-right:.75rem}.v-accordion-item__header__actions__icon[data-v-d0ab29da]{font-size:1.25rem;transition:transform var(--g-transition-speed)}.v-accordion-item__content[data-v-d0ab29da]{padding:1rem}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__ = "data-v-d0ab29da";
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);
var __vue_component__$1 = __vue_component__;
export { __vue_component__$1 as default };